// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","button":"HXjl52","disabled":"rGnbGR","selected":"OJHPvr"};